import { Slider } from 'components/slider'

export const SliderMythology = () => (
  <Slider
    maximumWidth={564}
    preferHeight
    slides={[
      {
        src: require(`./assets/slider/Myth_En.webp`),
        title: 'Ён',
        description:
          'Один из создателей человека и животного мира. Ён играет важную роль в мифах и представлениях о происхождении вселенной у коми. Он сотворил все хорошее и заботился о людях.',
      },
      {
        src: require(`./assets/slider/Myth_Omol.webp`),
        title: 'Омöль',
        description:
          'Один из двух высших богов в мифологии коми, брат и антагонист бога Ёна. Его имя переводят как "плохой", "гадкий". Его представляют в виде лебедя, утки, голубя, иногда в виде лягушки.',
      },
      {
        src: require(`./assets/slider/Myth_Voypel.webp`),
        title: 'Войпель',
        description:
          'Сын бога Ёна, это божество, которое, по преданию, имеет власть над ветрами, вьюгой, снегопадом. Он занимает одну из высших ступеней в иерархии божеств и в переводе означает "северный ветер", иногда коми называют его "северное ухо" или "ночное ухо". Войпель защищает людей от невзгод.',
      },
      {
        src: require(`./assets/slider/Myth_Yoma.webp`),
        title: 'Йома',
        description:
          'Злая лесная ведьма, колдунья с длинными волосами, железными зубами и длинным носом, живет на опушке леса в небольшой избе и владеет злыми чарами. Коми верили, что она наделена властью над злаками, флорой и фауной, распоряжается живой и мертвой водой, хранит огонь и волшебные предметы.',
      },
      {
        src: require(`./assets/slider/Myth_Chud.webp`),
        title: 'Чудь',
        description:
          'Для коми-зырян и коми-пермяков чудь считается прародителем. В разных фольклорных традициях их представляют либо как сопротивлявшийся христианизации героический народ, либо как глупцов. В основном чудь жила в лесах. Некоторые из них приняли христианство и стали коми. Другие же, не желая принимать новую веру, похоронили себя в глубоких ямах в лесу. Также в одном из поверий чудь превратилась в злых духов, которые скрываются в темных местах, заброшенных жилищах, банях и даже под водой. Истории о ней есть почти у всех финно-угорских народов.',
      },
      {
        src: require(`./assets/slider/Myth_Gundyr.webp`),
        title: 'Гундыр',
        description:
          'В коми-зырянском фольклоре Гундыр – чаще отрицательный персонаж. Он похищал людей и солнце. Изначально Гундыр имел человеческий образ, но под влиянием русского фольклора его стали изображать в виде большой змеи или дракона. Считается, что у него "нечистое дыхание" и душа. Чаще всего Гундыр появляется из-под воды или прилетает в виде сьöд кымöр (черной тучи), лöз ру (синего тумана), сьöд тшын (черного дыма).',
      },
    ]}
  />
)
